import type { JSX } from 'react';

import { useTranslate } from '../i18n/useTranslate.js';
import { cn } from '../primitives/utils.js';
import type { AnalyticsConsentContextValue } from './AnalyticsConsentProvider.js';

/** Announces why the last analytics choice was not authoritatively saved. */
export function ConsentSaveError({
  error,
  className,
}: {
  readonly error: AnalyticsConsentContextValue['saveError'];
  readonly className?: string;
}): JSX.Element | null {
  const t = useTranslate();
  if (error === null) {
    return null;
  }
  return (
    <p role="alert" className={cn(className, 'text-sm text-destructive')}>
      {t(error === 'stale' ? 'analytics.consent.notice.stale' : 'analytics.consent.notice.failed')}
    </p>
  );
}
